import { render, staticRenderFns } from "./airports.vue?vue&type=template&id=4ea93e52&scoped=true&"
import script from "./airports.vue?vue&type=script&lang=ts&"
export * from "./airports.vue?vue&type=script&lang=ts&"
import style1 from "./airports.vue?vue&type=style&index=1&id=4ea93e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea93e52",
  null
  
)

export default component.exports